import { cva } from "class-variance-authority";

export const INPUT_STATES = {
  NORMAL: "normal",
  ERROR: "error",
} as const;

export type InputState = (typeof INPUT_STATES)[keyof typeof INPUT_STATES];

export const inputVariants = cva(
  "flex w-full rounded-md px-3 text-base md:text-sm bg-transparent transition-colors placeholder:text-muted-foreground focus-visible:outline-none disabled:cursor-not-allowed disabled:opacity-50",
  {
    variants: {
      state: {
        normal: "",
        error: "border-destructive focus-visible:ring-destructive",
      },
      bordered: {
        true: "border border-gray-300",
        false: "",
      },
      variant: {
        default: "",
        integrated:
          "border-none shadow-none px-0 focus:ring-0 focus-visible:ring-0 focus-visible:ring-offset-0 text-base md:text-[15px] font-normal text-gray-700 placeholder:text-base md:placeholder:text-[15px] placeholder:text-gray-500",
        "bordered-integrated":
          "border border-gray-300 shadow-none px-3 focus:ring-0 focus-visible:ring-0 focus-visible:ring-offset-0 text-base md:text-[15px] font-normal text-gray-700 placeholder:text-base md:placeholder:text-[15px] placeholder:text-gray-500",
        file: "file:border-0 file:bg-transparent file:text-base md:file:text-[15px] file:font-medium",
      },
      size: {
        sm: "h-8 text-sm",
        default: "h-9",
        lg: "h-11 text-lg",
      },
    },
    compoundVariants: [
      {
        variant: "default",
        bordered: false,
        class: "border border-input",
      },
      {
        variant: "default",
        bordered: true,
        class: "border border-gray-300",
      },
      {
        variant: "bordered-integrated",
        state: "error",
        class: "!border-red-500 focus-visible:ring-red-500",
      },
    ],
    defaultVariants: {
      state: "normal",
      bordered: false,
      variant: "default",
      size: "default",
    },
  }
);

export const INPUT_STYLES = {
  base: "flex w-full rounded-md px-3 text-base md:text-sm bg-transparent transition-colors placeholder:text-muted-foreground focus-visible:outline-none disabled:cursor-not-allowed disabled:opacity-50",
} as const;

export const inputBaseStyles = {
  container:
    "relative flex h-16 flex-1 cursor-pointer items-stretch border border-neutral-200 bg-white hover:bg-accent/5",
  input:
    "flex h-full w-full bg-transparent px-3 py-2 text-base md:text-[15px] font-normal text-gray-700 shadow-none focus:outline-none focus:ring-0 transition-colors placeholder:text-gray-500 placeholder:text-base md:placeholder:text-[15px] disabled:cursor-not-allowed disabled:opacity-50",
  iconWrapper: "absolute left-3 top-1/2 -translate-y-1/2 z-10",
  icon: "w-5 h-5 text-muted-foreground",
} as const;
